import { ReactElement, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, useNavigate } from 'react-router-dom';

import { GoBackButtonWithTitle } from 'components';
import { useSubscription } from 'hooks';

import { InviteEmployeesForm, InviteEmployeesPageHeader } from '../../components';
import { ContentW, PageW, PostSubmissionNote } from './styled';

type LocationState = {
  submitted: boolean;
};

export function InviteEmployeePage(): ReactElement {
  const [formHasContent, setFormHasContent] = useState(false);

  const { t } = useTranslation();
  const { isTrial } = useSubscription();
  const navigate = useNavigate();

  const { state } = window.history;
  const isSubmitted = (state as LocationState)?.submitted;
  const pageContent = isSubmitted ? (
    <PostSubmissionNote>{t('inviteEmployee.postSubmissionNote')}</PostSubmissionNote>
  ) : (
    <InviteEmployeesForm setFormHasContent={setFormHasContent} />
  );

  if (isTrial) {
    return (
      <Navigate
        to={{
          pathname: 'not-found',
        }}
      />
    );
  }

  return (
    <PageW>
      <GoBackButtonWithTitle
        title={t('common.back')}
        onClick={() => navigate(-1)}
        containerSx={{
          marginTop: 0,
          maxWidth: '100%',
        }}
      />
      <InviteEmployeesPageHeader formHasContent={formHasContent} />
      <ContentW>{pageContent}</ContentW>
    </PageW>
  );
}
